import { AxiosResponse } from "axios";
import API from "../api";
import { Item } from "../models/item";

const ItemsService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/items/count`, { params: options });
  },
  async getTypes(options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/item/types`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Item[]>> {
    return await API.get(`/items`, { params: options });
  },
  async create(item: Item): Promise<AxiosResponse<Item[]>> {
    return await API.post("/items", item);
  },
  async update(itemId: number, item: Item): Promise<AxiosResponse<boolean>> {
    return await API.put(`/items/${itemId}`, item);
  },
  async updateList(items: Item[]): Promise<AxiosResponse<boolean>> {
    return await API.put(`/items/list`, items);
  }
};

export default ItemsService;
